const USER_LOAD = 'USER_LOAD';
const USER_LOGOUT = 'USER_LOGOUT';

export const types = {
    USER_LOAD,
    USER_LOGOUT
};

/**
 *
 * This is the hard logout - meaning the user
 * is intentionally logging out. Everything
 * will reset.
 *
 */

export function userLogout() {
    // USE THE SAME ACTION TYPE
    // WE ARE DESTROYING THE SESSION
    // ON THE CLIENT NO MATTER WHAT
    return {
        type: USER_LOGOUT,
        track: true
    };
}

/**
 *
 * This action loads the user into redux.
 *
 */

export function userLoad(payload) {
    return {
        type: USER_LOAD,
        payload
    };
}
